import styled from 'styled-components';
import { width, space } from 'styled-system';
import { Button } from 'components/core';
import { Typography } from 'src/typography';

export const ListContainer = styled.div`
  margin-top: 34px;
  width: 100%;
`;

export const ListItemContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${space}
`;

export const ListItemCellContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${width}
`;

export const ListItemSecondaryHeader = styled.label`
  font-weight: bold;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.grey[60]};
  line-height: 150%;
  text-transform: uppercase;
`;

export const ListItemMainHeader = styled.h4`
  font-size: 16px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

export const DataContainer = styled.p`
  font-size: 13px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

export const TabHeaderTitle = styled(Typography.Heading)`
  margin-bottom: 35px;
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

export const StyledButton = styled(Button)`
  margin-top: 45px;
  height: 51px;
  padding: 12px 23px;
  width: 100%;
  font-size: 15px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: initial;
    height: 40px;
    font-size: 13px;
    margin-top: 64px;
  }
`;
